import { LOCALES } from '../constants';

export default {
  [LOCALES.UKRAINE]: {

    //INTRODUSING SECTION PAGE
    'introducing_hello': 'Привіт',
    'introducing_p2': 'Приємно познайомитися.',
    'introducing_im': 'Мене звуть',
    'introducing_name': 'Міша Губка.',
    'introducing_bio': `Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                    Voluptatum necessitatibus perferendis numquam dolorem cumque facilis.
                    Desir per po la ta doso vi slone ve`,

//NAVBAR SECTION
    'home_link':'Головна',
    'about_link':'Про мене',
    'skills_link':'Навики',
    'projects_link':'Проекти',
    'contact_link':'Контакти',
    'footer':'2022 Міша Губка',

//ABOUT PAGE SECTION
    'about_title':'Про мене',
    'about_title_span':'Про мене',
    'about_title_Skills':'Мої навики',
    'about_title_Skills_span':'Мої навики',

//ABOUT PAGE IMAGE SECTION
    'about_img_section_fullname': `Iм'я`,
    'about_img_section_age': 'Вік',
    'about_img_section_nationality': 'Національність',
    'about_img_section_languages': 'Мови',
    'about_img_section_address': 'Адреса',
    'about_img_section_countries': 'Країна',

    'about_img_section_fullname_r': 'Mіша Губка',
    'about_img_section_age_r': '29',
    'about_img_section_nationality_r': 'Українець',
    'about_img_section_languages_r': 'Англійська, Українська, Російська',
    'about_img_section_address_r': 'Чернівецька область',
    'about_img_section_countries_r': 'Україна',
    'about_img_section_CV': 'Завантажити резюме',
    'app_title': 'Міша Губка',

    //PROJECT PAGE SECTION
    'project_main_title': 'Навчальні проекти',
    'project_main_title2': 'проект',
    'project1_title_1' : 'Netflix клон',
    'project_titlesourse': 'Програмний код',
    'project2_title_1': 'Coціальна мережа',
    'project2_description': 'Регістрація і сторінка постів. React.js Firebase',
    'project3_title_1': 'E-commerce вебсайт',
    'project4_title_1': 'Snapchat клон',

    //CONTACTS PAGE SECTION
    //CONTACT FORM SECTION
    'contact_form_title': `Зв'яжіться зі мною`,
    'contact_form_name': `Iм'я`,
    'contact_form_email': 'Електронна пошта',
    'contact_form_message': 'Повідомлення',
    'contact_form_send': 'Відправити',

    //CONTACT FORM VALIDATION
    'contact_form_name_field_required': `Обов'язкове поле`,
    'contact_form_name_maxLength' : 'Довжина Імені повинна бути менше 45 символів',
    'contact_form_email_required' : `Обов'язкове поле`,
    'contact_form_email_notvalid' : 'Пошта не придатна',
    'contact_form_message_required' : `Обов'язкове поле`,
    'contact_form_message_maxLength' : 'Довжина Повідомлення не повинна перевищувати 2000 символів',
    'contact_form_message_sent' : 'Повідомлення надіслано!',
    'contact_form_message_sent_Failed' : 'Не вдалося надіслати повідомлення! Будь-ласка спробуйте пізніше',

    //CONTACT FIELD
    'contact_field1_title': 'Телефон',
    'contact_field2_title': 'Електронна пошта',
    'contact_field3_title': 'Адреса',
    'contact-field_adress_text1': 'Чернівецька область',
    'contact-field_adress_text2': 'Україна',

    //CONTACT MAIN TITLE
    'contact_main_title1': 'Контакти',
    'contact_main_title2': 'Контакт',
  },
};
